import { addHours, format, parseISO } from 'date-fns';

interface VideoIntellectArchiveRequest {
  starttime: string;
}

interface DefaultArchiveRequest extends VideoIntellectArchiveRequest {
  mode: 'archive';
  isForward: 'true';
  speed: 1;
  sound: 'off';
  endtime: string;
}

export type ArchiveRequest = VideoIntellectArchiveRequest | DefaultArchiveRequest;

export function buildArchiveRequest(vendor: string, startTime: string): ArchiveRequest {
  const startTimeParsed = parseISO(startTime);
  const starttime = new Date(startTimeParsed).getTime() + new Date().getTimezoneOffset() * 60000;
  const endtime = addHours(starttime, 1);

  const formattedStartTime = format(starttime, 'dd.MM.yyyy HH:mm:ss');
  const formattedEndTime = format(endtime, 'dd.MM.yyyy HH:mm:ss');

  if (vendor === 'videointellect') {
    return {
      starttime: formattedStartTime,
    };
  }

  return {
    mode: 'archive',
    isForward: 'true',
    speed: 1,
    sound: 'off',
    starttime: formattedStartTime,
    endtime: formattedEndTime,
  };
}
